import React from 'react';
import PlayerProfile from './sub/PlayerProfile';
import PlayerSeasonRecord from './sub/PlayerSeasonRecord';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PlayerBasicData from './sub/PlayerBasicData';

function ProfileMain(props) {
    let playerObj = props['profile'];

    return (
        <>
        <Row>
            <Col md={4}>
                <PlayerBasicData profile={playerObj} />
            </Col>
            <Col md={8}>
                <PlayerSeasonRecord profile={playerObj} />
            </Col>
        </Row>
        </>
    );
}

export default ProfileMain;